
//　header menu
const openBtn  = document.querySelector('.navi-open');
const closeBtn = document.querySelector('.navi-close');
const mobileNav = document.getElementById('lnr_global_navi_mobile');

let scrollY = 0;

openBtn.addEventListener('click', () => {
    scrollY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollY}px`;
    document.body.style.width = '100%';
    document.body.style.overflow = 'hidden';
    mobileNav.classList.add('is-open');
    const navScroll = mobileNav.querySelector('.global_nav');
    if (navScroll) navScroll.scrollTop = 0;
});

closeBtn.addEventListener('click', () => {
    mobileNav.classList.remove('is-open');
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    document.body.style.overflow = '';
    window.scrollTo(0, scrollY);
});



$(function () {
$(".child-menu-list").css("display", "none");
$('._has_child').on('click', function () {
    $(this).next().slideToggle(300);
    $(this).toggleClass('open');
});
});


//　FAQ
$(function () {
$(".faq__a").css("display", "none");
$('.faq__q').on('click', function () {
    $(this).next().slideToggle(300);
    $(this).toggleClass('open');
});
});

//　Guide menu
document.addEventListener('DOMContentLoaded', () => {

    const sections = document.querySelectorAll('.guide__block');
    const menuLinks = document.querySelectorAll('.guide__menu_link');

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {

        const id = entry.target.getAttribute('id');
        const activeLink = document.querySelector(`.guide__menu_link[href="#${id}"]`);

        if (entry.isIntersecting) {

            menuLinks.forEach(link => link.classList.remove('is-active'));

            if (activeLink) {
            activeLink.classList.add('is-active');
            }

        }
        });
    }, {
        root: null,
        rootMargin: "0px 0px -30% 0px", 
        threshold: 0.2
    });

    sections.forEach(section => observer.observe(section));

    });

// SNSシェア
$(function() {

    let pageurl = window.location.href;
    let pagetitle = document.title;

    let snsShareBtns = document.querySelectorAll(".snssharebtn");
    snsShareBtns.forEach(function(ssb) {
        
        let target = ssb.getAttribute('href');
        target = target.replace('{URL}', encodeURIComponent(pageurl));
        target = target.replace('{TITLE}', encodeURIComponent(pagetitle));
        ssb.setAttribute('href', target);
    });

    });

// Title URL Copy
function urlCopy() {
    var url = location.href; 
    var title = document.title;
    navigator.clipboard.writeText("【"+title +"】"+" " + url);
    document.getElementById("urlcopyBtn").value="リンクをコピーしました";
}

// animation
document.addEventListener("DOMContentLoaded", function() {

  const targets = document.querySelectorAll(".fade-up");

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add("is-active");
      }
    });
  }, {
    threshold: 0.2
  });

  targets.forEach(target => observer.observe(target));

});

document.addEventListener("DOMContentLoaded", function() {

  const lists = document.querySelectorAll(".fade-up-stagger");

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {

        const items = entry.target.querySelectorAll("li");

        items.forEach((item, index) => {
          item.style.transitionDelay = index * 0.2 + "s";
        });

        entry.target.classList.add("is-active");
      }
    });
  }, { threshold: 0.2 });

  lists.forEach(list => observer.observe(list));

});


//　DEMO
document.addEventListener("DOMContentLoaded", function(){

  const modal = document.getElementById("videoModal");
  const video = document.getElementById("modalVideo");
  const source = document.getElementById("modalVideoSource");

  document.addEventListener("click", function(e){

    const openBtn = e.target.closest(".js-open-video");

    /* open */
    if(openBtn){

      const videoSrc = openBtn.dataset.video;

      source.src = videoSrc;
      video.load();

      modal.classList.add("active");

      video.play();

    }

    /* close */
    if(e.target.closest(".js-close-video")){

      modal.classList.remove("active");

      video.pause();
      video.currentTime = 0;

    }

  });

});